/**
 * @Desc: filters 过滤器
 * @Author: zuozuo
 * @Date: 2016-09-20
 **/
"use strict"
const moment = require('moment')
const defultPic = require('@/assets/img/defult.jpg')
/*
 * 显示微信图片
 * url | showWxImages
 */

const showWxImages = (url = null)=>{
	if(!url) return defultPic
//	return url
//	return 'http://read.html5.qq.com/image?src=forum&q=5&r=0&imgflag=7&imageUrl='+url
//	return  'http://hb-safe.com/article/show-image?image='+url
	return 'http://123.57.58.179/getpic.php?url='+url
}
const defultHeadPic = (url =null)=>{
	if(!url) return defultPic
	return url
}
/*
 * 类型
 * 'text' | filterOsType
 */
const filterOsType = (type = null) => {
	switch (type){
		case 'Wechat':
			return '微信'
		case 'Alipay':
			return '支付宝'
		case 'UnionPay':
			return '刷卡'	
		default:
			return '其他'
	}
}
/*
 * 订单状态
 * 'text' | filterOrderStatus
 */
const filterOrderStatus = (status = null) => {
	switch (status){
		case 0:
			return '关闭'
		case 1:
			return '支付成功'
		case 2:
			return '待支付'
		case 3:
			return '已发货'
		case 4:
			return '退款中'
		case 5:
			return '退款成功'	
		default:
			return ''
	}
}
/*
 * 过滤微信素材类型
 * 'text' | filterMaterialType
 */
const filterMaterialType = (type = null) => {
	switch (type){
		case 'text':
			return '文字'
		case 'image':
			return '图片'
		case 'news':
			return '图文'
		case 'newsLink':
			return '图文外链'	
		case 'voice':
			return '语音'
		case 'video':
			return '视频'
		default:
			return ''
	}
}

/*
 * 截取字符
 * str | substr
 */
const substr = (str = '',length = 1)=>{
	return str.substr(0, length)
}

/*
 * 过滤金额
 * 1000 | filterMoney
 */
const filterMoney = (money = 0) => {
	if(typeof money === 'string') {
		money = parseInt(money);
	}
	return(money / 100).toFixed(2);
}

/*
 * 过滤折扣
 * 85 | formatDscount
 */
const formatDscount = (val = 0) =>{
	if(!val) return 0 
	return (val/10).toFixed(1)
}
/*
 * 隐藏手机中间四位
 * 18323341930 | formatPhone
 */
const formatPhone = (phone) => {
	if(typeof phone == 'number') {
		phone = phone.toString();
	}
	return phone.substr(0, 3) + '****' + phone.substr(-4);
}


/**
 * 日期格式化
 * 2015-12-12 12:01:12 | momentFmt "yyyy-MM-dd hh:mm:ss"
 */
const momentFmt=(time='',fmt='YYYY-MM-DD HH:mm:ss')=>{
	if(!time) return  '--'
	return moment(time).format(fmt);
}
/**
 * unix日期格式化
 * 2015-12-12 12:01:12 | momentUnixFmt "yyyy-MM-dd hh:mm:ss"
 */
const momentUnixFmt=(time='',fmt='YYYY-MM-DD HH:mm:ss')=>{
	return moment.unix(time).format(fmt);
}
module.exports = {
	filterMoney,
	formatPhone,
	momentFmt,
	momentUnixFmt,
	substr,
	filterMaterialType,
	filterOrderStatus,
	showWxImages,
	defultHeadPic,
	filterOsType,
	formatDscount
}


// WEBPACK FOOTER //
// ./src/filters/index.js